import Header from "./components/Header";
import Presale from "./components/Presale";
import Presale1 from "./components/Presale1";
import AuthState from "./conext";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
const AppWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};
function App() {
  const location = useLocation();  // ✅ Now inside Router
  const params = new URLSearchParams(location.search);
  const referralCode = params.get("ref");  // Extract referral code

  return (
 <AuthState referralCode={referralCode}>
      <Header />
      <Routes>
        <Route path="/thanks" element={<Presale1 />} />
        <Route path="*" element={
          <div>
             <Header/>
            <Presale/>
          </div>
        } />
      </Routes>
    </AuthState>




 
  );
}

export default AppWrapper;
